import { Button, FormControl, IconButton, Input, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { LockIcon } from '../../assets/icons/lock-icon';
import styles from './login.module.scss'
import { Box } from '@mui/system';
import { KeyIcon } from '../../assets/icons/key-icon';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
const Login = () => {
    const navigate = useNavigate();
    const [authKey, setAuthKey] = useState(null);
    function handleSignin() {
        if (authKey == null) { alert("Please add key") }
        else if (authKey.toString() === "123") {
            localStorage.setItem("role", "user")
            navigate("/chats")
        }
        else if (authKey.toString() === "321") {
            localStorage.setItem("role", "admin")
            navigate("/admin/chats")
        }
        else { alert("/Invalid key") }

    }
    return (
        <div className={styles.container}>
            <div className={styles.login_container}>
                <div className={styles.title_icon_container}>
                    <LockIcon />
                    <div className={styles.title}>Sign in</div>
                </div>
                <Box className={styles.form_container}>
                    {/* key input */}
                    <div className={styles.input_container}>
                        <InputLabel htmlFor="key" className={styles.input_label}>Auth Key*</InputLabel>
                        <FormControl sx={{ width: '100%' }} variant="outlined">
                            <OutlinedInput
                                required
                                id="key"
                                type={'text'}
                                startAdornment={
                                    <InputAdornment position="end" sx={{ mr: '10px', ml: '-5px' }}>
                                        <KeyIcon />
                                    </InputAdornment>
                                }
                                value={authKey}
                                onChange={e => setAuthKey(e.target.value)}
                            />
                        </FormControl>
                    </div>

                    {/* button */}
                    <Button onClick={handleSignin} className={styles.btn} variant="contained">Sign in</Button>
                </Box>
            </div>
        </div>
    )


}

export default Login;